import { EventParticipationsRepository } from '@lib/api/repository/event-participations/event-participations.repository';
import {
  ChangeParticipationInput,
  EventParticipation,
  PARTICIPATION_STORE_PAGE_SIZE,
  ParticipationFilters,
  ParticipationPage,
  ParticipationStores,
  ParticipationView,
} from '@lib/types/event-participation';

import {
  EventParticipationDTO,
  ParticipationPageDTO,
  ParticipationStoresDTO,
  toParticipation,
  toStore,
} from './models';
import { Requester } from '../clients';

const PATH = '/marketplace/events';

export default class EventParticipationsAPI implements EventParticipationsRepository {
  async list(
    eventId: string,
    view: ParticipationView,
    filters: ParticipationFilters,
    signal?: AbortSignal,
  ): Promise<ParticipationPage> {
    const { data } = await Requester.get<ParticipationPageDTO>(
      `${PATH}/${encodeURIComponent(eventId)}/participations${view === 'public' ? '' : `/${view}`}`,
      { params: { ...filters }, signal },
    );

    return {
      items: data.items.map(toParticipation),
      total: data.total,
      page: data.page,
      limit: data.limit,
      summary: data.summary
        ? { confirmed: data.summary.confirmed, pending: data.summary.pending }
        : undefined,
    };
  }

  async stores(
    search: string,
    page: number,
    admin: boolean,
    signal?: AbortSignal,
  ): Promise<ParticipationStores> {
    const { data } = await Requester.get<ParticipationStoresDTO>(
      `${PATH}/${admin ? 'participants/candidates' : 'participants/stores'}`,
      { params: { search, page, limit: PARTICIPATION_STORE_PAGE_SIZE }, signal },
    );

    return {
      items: data.items.map(toStore),
      total: data.total,
      page: data.page,
      limit: data.limit,
    };
  }

  async change(input: ChangeParticipationInput): Promise<EventParticipation> {
    const { data } = await Requester.post<EventParticipationDTO>(
      `${PATH}/${encodeURIComponent(input.eventId)}/participations`,
      {
        body: {
          action: input.action,
          storeId: input.storeId,
          onSiteSales: input.onSiteSales,
          preOrders: input.preOrders,
          preOrderDeadline: input.preOrderDeadline,
          expectedRevision: input.expectedRevision,
          reason: input.reason,
        },
      },
    );

    return toParticipation(data);
  }
}
